<template>
    <pembayaran-supplier is-create-nota></pembayaran-supplier>
</template>

<script>
import PembayaranSupplier from '../pembayaran-suppliers/Index';

export default {
    name: "nota-supplier-create",

    components: {
        PembayaranSupplier,
    },

    data() {
        return {
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
    },

    methods: {
    },
}
</script>
